import { useState, useEffect, useRef } from "react";
import { Form, Row, Col, Button, Container } from "react-bootstrap";
import useApi from "../../Hooks/useApi";
import * as api from "../../api/getapi";
import * as postapi from "../../api/postapi";
import { toast } from "react-toastify";
import ReactSelect from "./../../Components/ReactSelect";
import CustomizeTableview from "../../Components/TableViews/CustomizeTableview";
import SearchableSelect from "../../Components/SearchableSelect";
import { useNavigate } from "react-router-dom";
import PaginationBar from "../../Components/PaginationBar";
import moment from "moment";
import DatePicker from "../../Components/DatePicker/DatePicker";

const ProcessSellerPayments = () => {
  const navigate = useNavigate();
  const [validatedVendor, setValidatedVendor] = useState(false);
  const dropdownShops = useApi(api.getDropdownShops);
  const [shop, setShop] = useState(null);
  const [error, setError] = useState("");
  const [payments, setPayments] = useState([]);
  const [payable, setPayable] = useState(0);
  const [settlementType, setSettlementType] = useState({ value: null, label: "Select Settlement Type" });
  const [noOfPages, setNoOfPages] = useState(1);
  const [sizeOfPages, setSizeOfPages] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPayments, setTotalPayments] = useState();
  const [selectedItems, setSelectedItems] = useState([]);
  const [fromDate, setFromDate] = useState(moment().subtract(100, "years")._d);
  const [toDate, setToDate] = useState(moment().add(100, "years")._d);
  const fetchAllSellerPayments = useApi(api.fetchAllSellersOrders, { hasCatchError: true });
  const paymentProcessRequests = useApi(postapi.SellerPaymentProcessRequest, { hasCatchError: true });
  const changePage = (page) => {
    setCurrentPage(page);
  };
  const getShops = async (searchInput) => {
    return new Promise((resolve, reject) => {
      dropdownShops
        .request(searchInput)
        .then((res) => {
          const getData = res?.data?.map((cat) => ({
            value: cat,
            label: (
              <>
                <strong className="fs-12" name={cat.shop_name}>
                  {cat.id}-{cat.shop_name}
                </strong>
                <p className="fs-10 text-lowercase">
                  {cat.whatsapp} <br />
                  {cat.username}
                </p>
              </>
            ),
            name: cat.shop_name + " [" + cat.id + "]",
          }));
          resolve(getData);
        })
        .catch((err) => {
          reject("err" + err);
        });
    });
  };
  const handleShopChange = (e) => {
    if (!e) {
      setShop(null); // Set shop to null when cleared
      setSelectedItems([]);
      return;
    }

    setShop({
      value: e.value,
      label: e.name,
    });
    setSelectedItems([]);
    fetchShopsPayments(e.value.id);
  };

  const fetchShopsPayments = async (shopId) => {
    try {
      const res = await fetchAllSellerPayments.request({
        page: currentPage,
        size: sizeOfPages,
        fromDate: fromDate,
        toDate: toDate,
        search: shopId,
        status: "Pending",
        groupId: true,
      });
      const data = res?.data;
      setPayments(data.paymentsData);
      setTotalPayments(data.paginationData.no_of_items);
      if (data.paginationData.no_of_pages === 0) {
        setNoOfPages(1);
      } else {
        setNoOfPages(data.paginationData.no_of_pages);
      }
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    if (shop?.value?.id) {
      fetchShopsPayments(shop?.value?.id);
    } else {
      setPayments([]);
      setCurrentPage(1);
    }
  }, [shop, currentPage, toDate, fromDate]);
  useEffect(() => {
    const amountPayable = selectedItems?.reduce((total, payment) => {
      const netAmount = parseFloat(payment.net_payable) || 0; // Ensure it's a number
      return total + netAmount;
    }, 0);
    const finalAmount = amountPayable.toFixed(2);
    setPayable(finalAmount);
  }, [selectedItems]);
  const handleSettlementType = (e) => {
    if (e.value) {
      setSettlementType({ value: e.value, label: e.label });
    } else {
      setSettlementType({ value: null, label: "Select Settlement Type" });
    }
  };
  const handleRequestSubmit = async (e) => {
    e.preventDefault();

    if (shop?.value?.id && selectedItems.length > 0 && settlementType?.value) {
      try {
        const paymentIds = [];
        const ids = selectedItems?.map((item) => paymentIds.push(item.id));
        const data = {
          shopId: shop?.value?.id,
          paymentIds,
          settlementType: settlementType.value,
        };
        const res = await paymentProcessRequests.request(data);
        if (res) {
          toast.success("Request Added Successfully", {
            position: "bottom-right",
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          navigate("/orders/seller-payments");
        }
        if (paymentProcessRequests.error) {
          setError(paymentProcessRequests.error.data.error.message);
        }
      } catch (err) {
        setError(err.response.data.error.message);
      }
    }
  };
  return (
    <Container fluid>
      <div className="bg-white p-5 mx-0 mx-lg-5">
        <>
          <Form noValidate validated={validatedVendor} onSubmit={handleRequestSubmit}>
            {error && <div className="text-danger text-center my-1 rounded-1 w-100">*{error}</div>}
            <h3 className="border-bottom pb-2">Basics</h3>
            <Row className="">
              <Col md={6} className="py-2">
                <Form.Group className="w-100" controlId="formBasicShopName">
                  <label>
                    Shop<span className="text-danger">*</span>
                  </label>
                  <ReactSelect
                    placeholder="Select shop"
                    value={shop}
                    searchable={true}
                    options={getShops}
                    isClearable={true}
                    handleChange={handleShopChange}
                    onInputChange={(newInput) => {
                      return newInput;
                    }}
                  />
                  <Form.Control className="p-2" name="shop" hidden type="text" value={shop ? shop?.value : null} onChange={() => {}} required />
                  <Form.Control.Feedback type="invalid">* Please Select Shop</Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6} className="py-2">
                <Form.Group className="w-100" controlId="formBasicShopName">
                  <label>Select Day/Date</label>
                  <DatePicker important={true} fromDate={fromDate} toDate={toDate} setFromDate={setFromDate} setToDate={setToDate} />
                </Form.Group>
              </Col>

              <h3 className="border-bottom pt-3 pb-2">Orders</h3>

              {payments?.length === 0 ? (
                <div className="d-flex justify-content-center bg-light p-5">
                  <div className="text-center">No payments found</div>
                </div>
              ) : (
                <>
                  <CustomizeTableview
                    className={"mt-3"}
                    data={payments}
                    columnNotShow={["is_deleted", "paid_at", "is_paid", "settlement_type", "group_id"]}
                    dateColumn={["created_at", "updated_at"]}
                    status={{
                      column: ["payment_status"],
                      getClassName: ({ payment_status }) => {
                        if (payment_status === "Pending") {
                          return "text-warning";
                        } else if (payment_status === "Settled") {
                          return "text-success";
                        } else {
                          return "text-danger";
                        }
                      },
                      format: ({ payment_status }) => {
                        if (payment_status === "Pending") {
                          return "Pending";
                        } else if (payment_status === "Settled") {
                          return "Settled";
                        } else {
                          return "Declined";
                        }
                      },
                    }}
                    checkbox={{ get: selectedItems, setter: setSelectedItems, isFullRow: true }}
                    actions={false}
                  />
                  <Row className="mt-5 align-items-center">
                    <Col className="d-none d-md-block" md="3" lg="3">
                      <span className="text-secondary fs-6">{totalPayments} result(s)</span>
                    </Col>
                    <Col xs="12" md="6" lg="6">
                      <PaginationBar currentPage={currentPage} noOfPages={noOfPages} changePage={changePage} />
                    </Col>
                    <Col className="d-md-none d-flex align-items-center mt-3" xs="6" lg="3">
                      <span className="text-secondary fs-6">{totalPayments} result(s)</span>
                    </Col>
                  </Row>
                </>
              )}

              <h3 className="border-bottom pt-3 pb-2">Payment Details</h3>
              <Form.Group className="mt-1" as={Col} lg="6" md="6" sm="12" controlId="price">
                <label>
                  Payable <span className="text-danger">*</span>
                </label>
                <Form.Control value={payable} type="number" placeholder="Rs.1000" disabled />
                <Form.Control.Feedback type="invalid">Please Enter Amount</Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mt-1" as={Col} lg="6" md="6" sm="12" controlId="formBasicsettlementType">
                <label>
                  Settlement Type <span className="text-danger">*</span>
                </label>
                <SearchableSelect
                  placeholder="Settlement Type"
                  searchable={false}
                  value={settlementType}
                  options={[
                    { value: null, label: "Select Settlement Type" },
                    { value: "Instant", label: "Instant" },
                    { value: "Weekly", label: "Weekly" },
                    { value: "Monthly", label: "Monthly" },
                    { value: "Custom", label: "Custom" },
                  ]}
                  handleChange={handleSettlementType}
                />
              </Form.Group>
            </Row>
            <Row className="pt-5">
              <Col className="d-flex justify-content-center">
                <Button className="w-25" onClick={handleRequestSubmit} disabled={!(shop && selectedItems?.length > 0 && settlementType?.value)}>
                  Process Payment
                </Button>
              </Col>
            </Row>
          </Form>
        </>
      </div>
    </Container>
  );
};

export default ProcessSellerPayments;
